import "./assets/main.css";

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/es/components/message/style/css";
import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import getMainRouter from "./router/mainRouter";
import { showError } from "./utils/handleAPIError";
// import { authStore } from "./stores/authStore";
import { loadEnvConfig, setEnvConfig } from "./services/appConfig";
import { initializeAuthRecoveryMonitoring } from "./utils/authRecovery";

// read the SysOrg guid from the window name, switch, clear window name
const name = window.name;
if (name.startsWith("new-") && name.length === 40) {
  const sysOrgGuid = name.substring(4);
  sessionStorage.setItem("currentOrgGuid", sysOrgGuid);
  window.name = "";
}

async function init() {
  const env = await loadEnvConfig();
  setEnvConfig(env);
  initializeAuthRecoveryMonitoring();

  const router = getMainRouter();

  const pinia = createPinia();

  // Don't setup auth here - let the router guard handle it to prevent race conditions
  // This prevents duplicate initialization that can cause login loops

  const app = createApp(App);

  app.config.errorHandler = showError;
  app.use(ElementPlus);
  app.use(pinia);
  app.use(router);

  app.mount("#app");
}

init();
